import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-interactions',
  templateUrl: './interactions.component.html',
  styleUrls: ['./interactions.component.sass']
})
export class InteractionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
